import { EntryField } from '../util/common/entryField';
import { ListItemPicker } from '../util/listSelectField';
import { RadioGroup } from '../util/radioGroup';
import { TextField } from '../util/textFIeld';
import { InsuranceEntryItemType } from '@/types/bodyAndPaint';

interface InsuranceEntryField {
  state: InsuranceEntryItemType;
  setState: {
    insuranceSelect: (select: number) => void;
    companyPick: (pick: string) => void;
    certificateText: (text: string) => void;
    receiptNumberText: (text: string) => void;
    deductibleSelect: (select: number) => void;
    deductibleText: (text: string) => void;
    repairPlanSelect: (select: number) => void;
  };
  selectList: {
    insuranceSelect: string[];
    deductibleSelect: string[];
    repairPlanSelect: string[];
  };
  error: {
    certificateText: string;
    receiptNumberText: string;
    deductibleText: string;
  };
  picker: {
    inputID: string;
    containerID: string;
    select: string;
  };
  addInsurance?: boolean;
  isInsurance: boolean;
  hasDeductible: boolean;
}
export const InsuranceEntryField = ({
  state: {
    insuranceSelect: insuranceSelectState,
    certificateText: certificateTextState,
    receiptNumberText: receiptNumberTextState,
    deductibleSelect: deductibleSelectState,
    deductibleText: deductibleTextState,
    repairPlanSelect: repairPlanSelectState,
  },
  setState: {
    insuranceSelect: setInsuranceSelect,
    certificateText: setCertificateText,
    receiptNumberText: setReceiptNumberText,
    deductibleSelect: setDeductibleSelect,
    deductibleText: setDeductibleText,
    repairPlanSelect: setRepairPlanSelect,
  },
  selectList: {
    insuranceSelect: insuranceList,
    deductibleSelect: deductibleList,
    repairPlanSelect: repairPlanList,
  },
  error: {
    certificateText: certificateError,
    receiptNumberText: receiptNumberError,
    deductibleText: deductibleError,
  },
  picker: { inputID, containerID, select },
  addInsurance,
  isInsurance,
  hasDeductible,
}: InsuranceEntryField) => {
  return (
    <div className={'insurance-entry-field'}>
      <div className={'insurance-entry-content'}>
        <div className={'entry-use-insurance-label'}>
          <span>{'保険の利用・詳細について'}</span>
        </div>
        {!addInsurance && (
          <>
            {isInsurance && (
              <div className={'insurance-note'}>
                <span>{'お手元に保険証書をご準備ください'}</span>
              </div>
            )}
            <EntryField label={'保険を利用しますか？'} required={true}>
              {!isInsurance && (
                <div className={'check-in-reserve-note'}>
                  <span>
                    {
                      '※保険を利用するか否かのご判断は、お見積もり後に再度ご確認いたしますので、現時点で確定していなくても結構です。'
                    }
                  </span>
                </div>
              )}
              <RadioGroup
                groupName={'use-insurance'}
                list={insuranceList}
                value={insuranceSelectState}
                onChange={setInsuranceSelect}
              />
            </EntryField>
          </>
        )}
        <div
          style={{
            width: '100%',
            display: isInsurance ? 'flex' : 'none',
          }}
        >
          <EntryField label={'保険会社'} required={true}>
            <ListItemPicker
              pickerSelect={select}
              pickerInputID={inputID}
              pickerContainerID={containerID}
            />
          </EntryField>
        </div>
        {isInsurance && (
          <EntryField label={'証券番号'} required={true}>
            <TextField
              value={certificateTextState}
              onChange={setCertificateText}
              pattern={certificateError}
              placeholder={'アルファベットと数字'}
            />
          </EntryField>
        )}
        {isInsurance && (
          <EntryField label={'事故受付番号'} required={true}>
            <TextField
              value={receiptNumberTextState}
              onChange={setReceiptNumberText}
              pattern={receiptNumberError}
              placeholder={'000000000000000000'}
            />
          </EntryField>
        )}
        {isInsurance && (
          <EntryField label={'免責金はありますか'} required={true}>
            <RadioGroup
              groupName={'has-deductible'}
              list={deductibleList}
              value={deductibleSelectState}
              onChange={setDeductibleSelect}
            />
          </EntryField>
        )}
        {isInsurance && hasDeductible && (
          <EntryField label={'免責金'}>
            <TextField
              value={deductibleTextState}
              onChange={setDeductibleText}
              pattern={deductibleError}
              placeholder={'0000円'}
            />
          </EntryField>
        )}
        {isInsurance && (
          <EntryField label={'見積後の修理予定'} required={true}>
            <RadioGroup
              groupName={'repair-planning'}
              list={repairPlanList}
              value={repairPlanSelectState}
              onChange={setRepairPlanSelect}
            />
          </EntryField>
        )}
      </div>
    </div>
  );
};
